
import { Component, HostListener, Input, TemplateRef, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Popover } from 'primeng/popover';

import { NavigationService } from '../../service/navigation.service';
import { AuthContext, AuthContextService } from '../../../core/authentication/auth-context.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  standalone: false
})
export class NavbarComponent {
  @Input() title: string = '';
  @Input() btnBack: boolean = true;
  @Input() btnHome: boolean = true;
  @Input() btnConfig: boolean = true;
  @Input() btnPdf: boolean = true;
  @Input() customBackButton: TemplateRef<any> | null = null;

  @ViewChild('op') op!: Popover;

  public acompanhamento: boolean = false;
  public user: any = {};
  public menuOpen: boolean = false;

  constructor(
    router: Router,
    private location: Location,
    private navigation: NavigationService,
    private authContextService: AuthContextService
  ) {
    this.carregarDadosUsuario();
  }

  private carregarDadosUsuario(): void {
    this.authContextService.context$.subscribe({
      next: (contexto: AuthContext | null) => {
        this.user = contexto ?? {};
        this.acompanhamento = this.authContextService.hasPapel('PRO_CHE', 'PRO', 'DESENV001');
      },
      error: (error: unknown) => {
        console.error('Erro ao recuperar os dados do usuário:', error);
        this.user = {};
        this.acompanhamento = false;
      }
    });
  }

  back(): void {
    window.history.back();
  }

  @HostListener('window:scroll', [])
  @HostListener('window:wheel', [])
  @HostListener('window:touchmove', [])
  onWindowScroll(): void {
    try {
      if (this.op) {
        this.op.hide();
      }
    } catch {
      // Não interrompe a tela caso o Popover ainda não esteja disponível.
    }
  }
}
